/**
 * What kind of medicine it is, and what one dose is counted in — docs/33 B5.
 *
 * "1 tablet" was said of every medicine, syrup included. Choosing the form
 * when adding one gives the reminder its own word: "5 ml", "2 puffs",
 * "1 application". The units offered follow the form; the first is the
 * default. A unit is counted, never converted or suggested: the amount is
 * still whatever the doctor wrote.
 */
export const DOSE_FORMS = [
  'tablet', 'capsule', 'syrup', 'drops', 'inhaler', 'injection', 'cream', 'patch', 'sachet', 'other',
] as const;
export type DoseForm = (typeof DOSE_FORMS)[number];

/** A picture beside each form's name on its chip. */
export const FORM_ICON: Record<DoseForm, string> = {
  tablet: '⚪', capsule: '💊', syrup: '🥄', drops: '💧', inhaler: '🌬️',
  injection: '💉', cream: '🧴', patch: '🩹', sachet: '📦', other: '➕',
};

/** The units a dose of each form is counted in; the first is the default. */
export const FORM_UNITS: Record<DoseForm, readonly string[]> = {
  tablet: ['tablet'],
  capsule: ['capsule'],
  syrup: ['ml', 'spoon'],
  drops: ['drop'],
  inhaler: ['puff'],
  injection: ['unit', 'ml'],
  cream: ['application'],
  patch: ['patch'],
  sachet: ['sachet'],
  other: ['dose'],
};

export function defaultUnit(form: DoseForm): string {
  return FORM_UNITS[form][0]!;
}

/** A unit that belongs to the form, or the form's default. */
export function unitFor(form: DoseForm, unit: string | null | undefined): string {
  return unit && FORM_UNITS[form].includes(unit) ? unit : defaultUnit(form);
}
